import './Accordion.css'
import React from "react";
import ReactDOM from "react-dom";

// const AccordionCategory =(props) =>{
class AccordionCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showMore: [] }; 
        this.toggleMore = this.toggleMore.bind(this);
    }
     
      
    toggleMore(event){
        event.preventDefault();
        let showMorecurrent = this.state.showMore[event.target.id] ? !this.state.showMore[event.target.id] : true;
        let arrShow= [...this.state.showMore];
        arrShow[event.target.id] = showMorecurrent;
        this.setState({ showMore : arrShow });
    } 
    
    render() {
        let items= null; 
        let title =this.props.Title;
        let formsRelevance= this.props.layout == 'first' ? 'לטפסים רלוונטיים' : 'להוראות רלוונטיות';
        if (this.props.type == "ContactUs"){
           // let formsRelevance= 'פרטי נגישות';
            let countLinks=  0;
            items= this.props.items.map((item, index)=>{
                let accessArea = <div className="accessArea accordion" id={"accessArea_"+ index}><div className="accordion-item">
                    <h2 data-toggle='collapse'  aria-expanded="true" aria-controls="collapseOne"  data-target={'#slide_'+ index} className='collapsed' >{formsRelevance} 
                        <i className={"fa fas fa-angle-up"}/></h2>
                    <div  id={'slide_'+ index}  className="collapse first " aria-labelledby={"accHead" + this.props.WpId +"_"+ this.props.index} 
                        data-parent={"accessArea_" + index } >dfd</div>
                        </div>
                </div>;
                return  <li className="card FormItem col-12" key={"AccordionCategory_"+index}>
                            <div className="row">
                                <div className="formDate col-6">{index}</div>   
                                
                            </div>
                            {accessArea}
                        </li>
                
                });
        }
        else if (this.props.type == "Form"){
            let formsRelevance= this.props.layout == 'first' ? 'לטפסים רלוונטיים' : 'להוראות רלוונטיות';
            title += (" (" +this.props.items.length + ")");
            items= this.props.items.map((item, index)=>{
                let countLinks=  0;
                let link1 =null;  
                let link2 =null;
                let link3 =null;
                let link4 =null;
                if(item.FaqLink1){
                    countLinks++;
                    link1=<a href={item.FaqLink1.NavigateUrl}><div className='moreLinkDiv'>{item.FaqLink1.Text}<i className="fa fa-arrow-left"/></div></a>
                }
                if(item.FaqLink2){
                    countLinks++;
                    link2=<a href={item.FaqLink1.NavigateUrl}><div className='moreLinkDiv'>{item.FaqLink2.Text}<i className="fa fa-arrow-left"/></div></a>
                }
                if(item.FaqLink3){
                    countLinks++;
                    link3=<a href={item.FaqLink1.NavigateUrl}><div className='moreLinkDiv'>{item.FaqLink3.Text}<i className="fa fa-arrow-left"/></div></a>
                }
                if(item.FaqLink4){
                    countLinks++;
                    link4=<a href={item.FaqLink1.NavigateUrl}><div className='moreLinkDiv'>{item.FaqLink4.Text}<i className="fa fa-arrow-left"/></div></a>
                }
                let moreLinks = countLinks === 0 ? null : (<div className="moreLinks accordion" id={"moreLinks_"+this.props.index}><div className="accordion-item">
                    <h2 data-toggle='collapse'  aria-expanded="true" aria-controls="collapseOne"  data-target={'#slide_'+this.props.index + index} className='collapsed' >{formsRelevance} ({countLinks}) 
                        <i className={"fa fas fa-angle-up"}/></h2>
                    <div  id={'slide_'+this.props.index+index}  className="collapse first " aria-labelledby={"accHead" + this.props.WpId +"_"+ this.props.index} 
                        data-parent={"moreLinks_" + this.props.index } >{link1}{link2}{link3}{link4}</div>
                        </div>
                </div>);
                return  <li className="card FormItem col-12" key={"AccordionCategory_"+index}>
                            <div className="row">
                                {/* <div className="formDate col-6">{ new Intl.DateTimeFormat('en-GB').format(new Date(item.Last_x0020_Modified))  }</div>    */}
                                <div className="formDate col-6">{moment(item.Last_x0020_Modified).format('DD/MM/YYYY')  }</div>   
                                <div className="formNumber col-6">{item.FormNumber}</div>   
                                <div className="FormContent col-12">{item.FormContent}</div>   
                                <div className="linkFormDiv "><a href={item.FileRef} download className="linkForm" aria-label={"להורדת "+item.FormContent}>להורדה</a></div>
                            </div>
                            {moreLinks}
                        </li>
                
                });
        } 
        else {
            items= this.props.items.map((item, index)=>{
            return <li className="LinkItem col-12 col-md-4" key={"AccordionCategory_"+index}>
                      <a href={item.MODFooterLink.NavigateUrl} title={item.LinkTitle}>
                        <div className="LinkTitle">{item.LinkTitle}</div>   
                      </a>
                      <div className="yellowCorner"></div>
                    </li>
            
            });
        }
        return (
            <div className={'accordion-item modCard ' + (this.props.isOpen ? 'open' : '')} key={"AccordionCategory_"+this.props.WpId +"_"+ this.props.index}>
                <div className="title modCard-header " id={"accHead_" + this.props.WpId +"_"+ this.props.index} >
                    <h2 className="mb-0">
                        <a role="button" className="btn btn-link collapsed"  aria-expanded="false"  onClick={e => this.props.toggleItem(e)} data-toggle="collapse" data-target={"#accColapse_" + this.props.WpId +"_"+ this.props.index} 
                             aria-controls={"accColapse_" + this.props.WpId +"_"+ this.props.index} >
                        <span className="fa openclose"> </span>
                        {title}
                        </a>
                    </h2>
                </div>
                <div id={"accColapse_" + this.props.WpId +"_"+ this.props.index} className="collapse "  role="region" aria-labelledby={"accHead" + this.props.WpId +"_"+ this.props.index} 
                    data-parent={"#modAccordion_" + this.props.WpId }>
                    <div className="modCard-body row" >
                        <ul>
                            {items}
                        </ul>
                    </div>
                </div> 
            </div>
        )
    }
}


export default AccordionCategory;